import { render, staticRenderFns } from "./WebServiceConfigurationForm.vue?vue&type=template&id=bf5c0d7e&"
import script from "./WebServiceConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./WebServiceConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports